import { SiInstagram, SiX, SiLinkedin } from 'react-icons/si';
import { SOCIAL_LINKS } from '@/lib/index';

const iconMap = {
  instagram: SiInstagram,
  x: SiX,
  linkedin: SiLinkedin
};

export function SocialLinks() {
  return (
    <div className="flex items-center justify-center gap-6">
      {SOCIAL_LINKS.map((link) => {
        const Icon = iconMap[link.icon];
        if (!Icon) return null;
        
        return (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative"
            aria-label={link.name}
          >
            <div className="absolute inset-0 bg-primary/20 rounded-full blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <div className="relative p-3 bg-card/50 rounded-full border border-border group-hover:border-primary/50 transition-all duration-300">
              <Icon className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors duration-300" />
            </div>
          </a>
        );
      })}
    </div>
  );
}